var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { useDocumentProjects } from './useDocumentProjects';
import { useEditProjectDocuments } from './useEditProjectDocuments';
import { SelectProjectsMenu } from '../SelectProjectsMenu';
export function ManageProjectsMenu(props) {
    const { renderTarget, documentId, onClose, initiallyOpen } = props;
    const { documentProjects, loading } = useDocumentProjects(documentId);
    const { addToast } = useToast();
    const { addDocumentToProject, removeDocumentFromProject } = useEditProjectDocuments();
    const selectedProjectIds = documentProjects.map((project) => project.id);
    const getProjectDocumentNodeId = (projectId) => {
        var _a;
        const projectMatch = documentProjects.find((project) => project.id === projectId);
        if (!projectMatch) {
            return undefined;
        }
        return (_a = projectMatch.nodes.find((node) => node.documentId === documentId)) === null || _a === void 0 ? void 0 : _a.id;
    };
    const handleSelectProject = (project) => __awaiter(this, void 0, void 0, function* () {
        const isSelected = selectedProjectIds.includes(project.id);
        try {
            if (isSelected) {
                const nodeId = getProjectDocumentNodeId(project.id);
                if (!nodeId) {
                    throw Error();
                }
                yield removeDocumentFromProject(project.id, documentId, nodeId);
            }
            else {
                yield addDocumentToProject(project.id, documentId);
            }
        }
        catch (_a) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Failed to add document to project',
                    comment: 'Manage projects menu - Error toast when adding document to project',
                }),
                message: t({
                    message: 'Something went wrong when adding document to the project, please try again',
                    comment: 'Manage projects menu - Error toast message when adding document to project',
                }),
            });
        }
    });
    return (<SelectProjectsMenu loading={loading} initiallyOpen={initiallyOpen} onClose={onClose} renderTarget={renderTarget} selectedProjectIds={selectedProjectIds} onSelect={handleSelectProject}/>);
}
